import { Button, Divider, message, Modal, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { RiFileExcel2Fill } from "react-icons/ri";
import { InboxOutlined } from "@ant-design/icons";
import { Upload } from "antd";
import * as XLSX from "xlsx";
import { post } from "../../../apiService";

const { Dragger } = Upload;

export default function ImportProduct({ priceTypeSelect, priceColourTypeSelect }) {
  const [open, setOpen] = useState(false);
  const [fileUploaded, setFileUploaded] = useState(null);
  const [jsonData, setJsonData] = useState([]);
  const [fileList, setFiledList] = useState([]);
  const [msqText, setMesgText] = useState([]);
  const [loading, setLoading] = useState(false);

  const validData = [
    "Avg Weight",
    "Sieve",
    "Size(MM)",
    "HPK(" + priceTypeSelect + ")",
    "I1(" + priceTypeSelect + ")",
    "I2(" + priceTypeSelect + ")",
    "I3(" + priceTypeSelect + ")",
    "IF(" + priceTypeSelect + ")",
    "PK(" + priceTypeSelect + ")",
    "SI1(" + priceTypeSelect + ")",
    "SI2(" + priceTypeSelect + ")",
    "SI3(" + priceTypeSelect + ")",
    "VS1(" + priceTypeSelect + ")",
    "VS2(" + priceTypeSelect + ")",
    "VVS(" + priceTypeSelect + ")",
  ];

  const showModal = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const props = {
    className: "custom-upload",
    name: "file",
    fileList: fileList,
    accept: ".xlsx", // Corrected spelling from accespt to accept and lowercase xlsx
    action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
    multiple: false, // Restrict to one file
    onChange(info) {
      setFiledList([info.file]);
      setFileUploaded(info.file?.originFileObj);
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
      setFileUploaded(e.dataTransfer.files[0]?.originFileObj);
    },
  };

  useEffect(() => {
    const dbounce = setTimeout(() => {
      if (fileUploaded) {
        const reader = new FileReader();

        // Function to read file content
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });

          // Assuming you want to read the first sheet
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];

          // Convert sheet to JSON
          let json = XLSX.utils.sheet_to_json(worksheet);

          json = json.map((row) => {
            const newRow = { price: [] }; // Initialize price array
            Object.entries(row).forEach(([key, value]) => {
              const cleanKey = key.trim(); // Use trim() to remove extra spaces if any

              if (validData.includes(cleanKey)) {
                setMesgText([]);

                // Check if key contains parentheses
                const match = key.match(/(.*)\((.*)\)/);
                if (match && match[1] !== "Size") {
                  // Create original key without parentheses and new key from parentheses
                  const originalKey = match[1]; // Lowercase the key part
                  const newKey = match[2]; // Lowercase the parentheses part

                  // Push the price object to the price array
                  newRow.price.push({
                    priceType: originalKey,
                    type: newKey,
                    typeColor: priceColourTypeSelect,
                    price: value, // Use value directly
                  });
                } else {
                  // If no parentheses, just use lowercase and replace spaces
                  const cleanKey = key.toLowerCase().replace(/\s+/g, "_");
                  newRow[cleanKey] = value;
                }
              } else {
                setMesgText((prev) => [...prev, cleanKey]);
              }
            });
            return newRow;
          });

          setJsonData(json); // Store the JSON data in state
        };

        reader.readAsArrayBuffer(fileUploaded); // Read the file as ArrayBuffer
      }
    }, 300);

    return () => clearTimeout(dbounce);
  }, [fileUploaded]);

  const formSubmit = async () => {
    if (jsonData.length > 0) {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("action", "upload");
        formData.append("product", JSON.stringify(jsonData));
        const resp = await post("/product.php", formData);

        if (resp) {
          setLoading(false);
          message.success("File uploaded successfully.");
          setOpen(false);
          setMesgText([]);
          setFileUploaded(null);
          setFiledList([]);
          setJsonData([]);
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
        message.error("Unable to upload product please try again.");
      }
    } else {
      message.error("No data found");
    }
  };


  return (
    <Spin spinning={loading}>
      <Button
        onClick={showModal}
        style={{ background: "green", color: "#fff" }}
        icon={<RiFileExcel2Fill />}
      >
        Import Product
      </Button>

      <Modal
        title="Upload Product"
        open={open}
        onCancel={handleCancel}
        okText="Upload Product"
        okButtonProps={{
          style: { backgroundColor: "var(--primeColor)", color: "white" },
        }}
        onOk={formSubmit}
        centered
      >
        <Dragger {...props}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            Click or drag file to this area to upload
          </p>
          <p className="ant-upload-hint">Only .xlsx file support</p>
        </Dragger>
        <Divider />
        {msqText?.length > 0 && (
          <span className="text-danger">
            ({msqText.join(", ")}) - Not found columns or check spelling or
            check space in column
          </span>
        )}
      </Modal>
    </Spin>
  );
}
